/// <reference path="./typings/knockout/knockout.d.ts" />

const $ = (window as any).jQuery;
const ko = (window as any).ko as KnockoutStatic;

export function initSvgParser() {

    ko.bindingHandlers["svg"] = {
        init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            const url = valueAccessor();
            const request = new XMLHttpRequest();
            request.open("GET", url, true);
            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    if (request.status === 200 || request.status === 0) {
                        $(element).replaceWith(request.response);
                    }
                }
            };
            request.send();
        }
    };
}